import { useState, useEffect, useContext } from "react";
import { Table, Card, Spin, message } from "antd";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";

export default function Pips() {

    const { authData, backUrl } = useContext(AuthContext);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchPipTasks = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${backUrl}/api/piprequest/pip-requests/?is_employee_view=true`,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );

            setData(response.data.results);
        } catch (error) {
            console.log(error);
            message.error("Failed to load PIP tasks");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPipTasks();
    }, []);

    // Format datetime
    const formatDate = (dateString) => {
        if (!dateString) return "—";
        const date = new Date(dateString);
        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    // Approvals inner table
    const approvalsColumns = [
        // { title: "Approver ID", dataIndex: "approver", key: "approver" },
        { title: "Approver Name", dataIndex: "approver_name", key: "approver_name" },
        { title: "Order", dataIndex: "order", key: "order" },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
        },
        {
            title: "Completed On",
            dataIndex: "completed_on",
            key: "completed_on",
            render: (value) => formatDate(value),
        },
        {
            title: "Remarks",
            dataIndex: "remarks",
            key: "remarks",
        },
    ];

    const columns = [
        { title: "ID", dataIndex: "id", key: "id" },

        { title: "Employee ID", dataIndex: ["employee", "emp_code"], key: "employee" },

        { title: "Employee Name", dataIndex: "employee_name", key: "employee_name" },

        // { title: "Created By ID", dataIndex: "created_by", key: "created_by" },

        { title: "Created By Name", dataIndex: "created_by_name", key: "created_by_name" },

        {
            title: "Created On",
            dataIndex: "created_at",
            key: "created_at",
            render: (value) => formatDate(value),
        },

        { title: "PIP Days", dataIndex: "pip_days", key: "pip_days" },

        { title: "Overall Status", dataIndex: "overall_status", key: "overall_status" },

        { title: "Reason", dataIndex: "reason", key: "reason" },
    ];

    return (
        <>
            {loading ? (
                <Spin size="large" />
            ) : (
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    pagination={{ pageSize: 10 }}
                    expandable={{
                        expandedRowRender: (record) => (
                            <Table
                                columns={approvalsColumns}
                                dataSource={record.approvals}
                                pagination={false}
                                rowKey="id"
                                size="small"
                                bordered
                            />
                        ),
                        rowExpandable: (record) => record.approvals?.length > 0,
                    }}
                    components={{
                        header: {
                            cell: (props) => (
                                <th {...props} style={{ backgroundColor: "#0e497b", color: "white" }}>
                                    {props.children}
                                </th>
                            ),
                        },
                    }}
                    bordered
                />
            )}
        </>
    );
}
